// src/Pages/Utils/authFetch.js
import BASE from '../../config';

export async function authFetch(url, options = {}) {
    const res = await fetch(url, {
        credentials: 'include',
        ...options,
    });

    if (res.status === 401 || res.status === 403) {
        // sessione scaduta / non valida
        localStorage.removeItem('isLoggedIn');
        localStorage.removeItem('username');
        localStorage.removeItem('userId');
        window.location.href = `${BASE}/login`;
        throw new Error('Unauthorized');
    }

    return res;
}
